
import React from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './error404.scss';






const Perror404 = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {





  
  
  
  

  
  return (
    <div id="id64aff0e88b8ac2e1bb827744" >

      <div id="iu8x" className="">
      
      <div id="in3m" className="">
      
      <div id="ipyf" className="">
      
      <div id="i29p" className="">
      
      <img
        className=""
        id="io5x"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk1558eu.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="ii0y4">
        <>Página No Encontrada</>
      </div>
      
      <div id="ib1zf" className="">
      
        <a
          target=""
          className=""
          id="irp6h"
          href="/"
        >
          
    <div id="ixafu" className="">
    <>Regresar</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Perror404);
  